import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';

export default function TextFieldWithToolTip(props) {
  const { tooltip, ...rest } = props;
  return (
    <Tooltip
      disableFocusListener={!props.disabled}
      disableHoverListener={!props.disabled}
      disableTouchListener={!props.disabled}
      title={tooltip}
    >
      <TextField {...rest} />
    </Tooltip>
  );
}
